"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _store = _interopRequireDefault(require("../redux/store"));
var generateReturnUrl = function generateReturnUrl(_ref) {
  var queryParams = _ref.queryParams,
    isMyAccount = _ref.isMyAccount;
  var _store$getState = _store.default.getState(),
    adyenConfiguration = _store$getState.publisherConfig.adyenConfiguration;
  var _ref2 = adyenConfiguration !== null && adyenConfiguration !== void 0 ? adyenConfiguration : {},
    myaccountReturnUrl = _ref2.myaccountReturnUrl,
    checkoutReturnUrl = _ref2.checkoutReturnUrl;
  var formatUrl = function formatUrl(url) {
    var paramsString = new URLSearchParams(queryParams).toString();
    return "".concat(url).concat(new URL(url).search ? '&' : '?').concat(paramsString);
  };
  if (isMyAccount && myaccountReturnUrl) return formatUrl(myaccountReturnUrl);
  if (!isMyAccount && checkoutReturnUrl) return formatUrl(checkoutReturnUrl);
  if (!queryParams) return window.location.href;
  return formatUrl(window.location.href);
};
var _default = generateReturnUrl;
exports.default = _default;